type RenderFunction = () => React.ReactNode;

export const stories: Record<string, RenderFunction> = {};

export const addStory = (name: string, renderFn: RenderFunction): void => {
  stories[name] = renderFn;
};
